import "./temporal-polyfill.js";

await import("./main.js");
